import MenuContentsContainer from 'components/feature/menu/list/MenuContentsContainer';

const MenuContentsPage = () => {
  return <MenuContentsContainer />;
};
export default MenuContentsPage;
